import React, { useEffect, useState } from "react";
import { UpdateStaffAPI } from "../../../utils/APIs/staffsApis";
import { getRolesAPI } from "../../../utils/APIs/RoleApis";
import { toast } from "react-toastify";

const EditStaffModal = ({ isOpen, onClose, staff, refreshData }) => {
  const [form, setForm] = useState({});
  const [roles, setRoles] = useState([]);
  console.log("first", staff)
  useEffect(() => {
  if (staff && roles.length > 0) {
    setForm({
      name: staff.name || "",
      email: staff.email || "",
      roleId: staff.role?._id || staff.role || "",
      status: staff.status || "Active",
    });
  }
}, [staff, roles]);


  useEffect(() => {
    if (isOpen) {
      fetchRoles();
    }
  }, [isOpen]);

  console.log("FORM",form.roleId)

  const fetchRoles = async () => {
    try {
      const res = await getRolesAPI(1, 100);
      setRoles(res?.data?.data || []);
    } catch {
      toast.error("Failed to load roles");
    }
  };

  if (!isOpen || !staff) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    try {
      const res = await UpdateStaffAPI(staff._id, form);

      if (res?.data?.success) {
        toast.success("Staff updated successfully");
        refreshData();
        onClose();
      }
    } catch {
      toast.error("Update failed");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>Edit Staff</h3>

        <input
          name="name"
          value={form.name || ""}
          onChange={handleChange}
        />

        <input
          name="email"
          value={form.email || ""}
          onChange={handleChange}
        />

        {/* ✅ Role Dropdown */}
        <select
          name="roleId"
          value={form.roleId || ""}
          onChange={handleChange}
          className="custom-select"
        >
          <option value="">Select Role</option>
          {roles.map((role) => (
            <option key={role._id} value={role._id}>
              {role.roleName}
            </option>
          ))}
        </select>


        <select
          name="status"
          value={form.status || ""}
          onChange={handleChange}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditStaffModal;
